import { ObjetKStatusCode, enumValue } from '@siclop/kstone-vue'
import { FieldType } from '@siclop/ksadmin-vue'

/**
 * Defines a type of property that can be used by wireframe components
 */
export class ComponentPropertyType extends ObjetKStatusCode {
  /** Field type (Boolean, Integer, Double, Text, Color, Select, etc.) */
  fieldType: FieldType = FieldType.Text

  /** Category for grouping properties (e.g., "Apparence", "Contenu") */
  category: string = ''

  /**
   * Format or options JSON.
   * For Select: ["option1", "option2"]
   * For Range: {"min": 0, "max": 100, "step": 1}
   * For Color: {"showAlpha": true}
   */
  optionsJson?: string

  /** Default value as string */
  defaultValue?: string

  /** Tooltip/help text */
  toolTip?: string

  /** Unit suffix (e.g., "px", "%", "deg") */
  unit?: string

  /** Is this a system property type (cannot be deleted) */
  isSystem: boolean = false

  constructor(data?: Partial<ComponentPropertyType>) {
    super(data)
    if (data) {
      this.fieldType = enumValue(FieldType, data.fieldType, FieldType.Text)
      this.category = data.category ?? ''
      this.optionsJson = data.optionsJson
      this.defaultValue = data.defaultValue
      this.toolTip = data.toolTip
      this.unit = data.unit
      this.isSystem = data.isSystem ?? false
    }
  }

  /**
   * Parse options JSON
   */
  get options(): unknown {
    if (!this.optionsJson) return null
    try {
      return JSON.parse(this.optionsJson)
    } catch {
      return null
    }
  }

  /**
   * Get select options as string array (for Select type)
   */
  get selectOptions(): string[] {
    const opts = this.options
    if (Array.isArray(opts)) return opts
    return []
  }

  /**
   * Get range options (for Range type)
   */
  get rangeOptions(): { min: number; max: number; step: number } {
    const opts = this.options as { min?: number; max?: number; step?: number } | null
    return {
      min: opts?.min ?? 0,
      max: opts?.max ?? 100,
      step: opts?.step ?? 1
    }
  }
}
